export const jobOpenings = [
  {
    id: 1,
    title: 'Senior AI/ML Engineer',
    type: 'Full-time',
    location: 'Remote',
    department: 'Engineering',
    postedDate: '2 days ago',
    description: 'Lead the development of cutting-edge AI/ML models and algorithms to solve complex business problems.',
    requirements: [
      '5+ years of experience in AI/ML development',
      'Strong Python and deep learning frameworks (TensorFlow/PyTorch)',
      'Experience with cloud platforms (AWS/GCP/Azure)'
    ],
    responsibilities: [
      'Design and implement machine learning models',
      'Collaborate with cross-functional teams',
      'Optimize model performance and scalability',
      'Mentor junior team members'
    ],
    qualifications: [
      'Bachelor\'s or Master\'s in Computer Science or related field',
      'Strong problem-solving skills',
      'Experience with MLOps practices'
    ]
  },
  {
    id: 2,
    title: 'Data Scientist',
    type: 'Full-time',
    location: 'New York, NY',
    department: 'Data Science',
    postedDate: '1 week ago',
    description: 'Analyze complex data sets to extract insights and build predictive models.',
    requirements: [
      '3+ years of experience in data science',
      'Proficiency in Python/R and data analysis libraries',
      'Experience with SQL and big data technologies'
    ],
    responsibilities: [
      'Analyze large datasets',
      'Develop predictive models',
      'Create data visualizations',
      'Present findings to stakeholders'
    ],
    qualifications: [
      'Degree in Statistics, Mathematics, or related field',
      'Strong analytical skills',
      'Experience with data visualization tools'
    ]
  },
  {
    id: 3,
    title: 'AI Product Manager',
    type: 'Full-time',
    location: 'San Francisco, CA',
    department: 'Product',
    postedDate: '3 days ago',
    description: 'Lead the development and strategy of our AI product portfolio.',
    requirements: [
      '4+ years of product management experience',
      'Experience with AI/ML products',
      'Strong analytical and problem-solving skills'
    ],
    responsibilities: [
      'Define product strategy',
      'Work with engineering and design teams',
      'Gather and prioritize requirements',
      'Analyze market trends'
    ],
    qualifications: [
      'Bachelor\'s degree in Business, CS, or related field',
      'Strong communication skills',
      'Experience in agile development'
    ]
  }
];
